import { render } from "./AttrStyleStats.vue?vue&type=template&id=1f200696"
import script from "./AttrStyleStats.vue?vue&type=script&lang=js"
export * from "./AttrStyleStats.vue?vue&type=script&lang=js"

import "./AttrStyleStats.vue?vue&type=style&index=0&id=1f200696&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrStyleStats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f200696"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f200696', __exports__)) {
    api.reload('1f200696', __exports__)
  }
  
  module.hot.accept("./AttrStyleStats.vue?vue&type=template&id=1f200696", () => {
    api.rerender('1f200696', render)
  })

}


export default __exports__